import { useEffect, useState } from "react";
import { useNavigate, Outlet, NavLink, Link } from "react-router-dom";
import { useAuth } from "../Providers/AuthProvider";
import agencyLogo from "../assets/images/adminPanel/bu.png";
import { getUserInfo } from "../services/getUserInfo";
import { useUser, useUserActions } from "../Providers/UserProvider";
import { logoutService } from "../services/logoutService";
import { Button, Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";

const Dashborad = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [imageLoading, setImageLoading] = useState(true);
  const { stateAuth } = useAuth();
  const user = useUser();
  const setUser = useUserActions();
  const navigate = useNavigate();
  const LOCAL_STORAGE_AUTH_KEY = "authState";

  const values = {
    id: stateAuth,
  };
  useEffect(() => {
    const getUserData = async () => {
      try {
        const { data } = await getUserInfo(values);
        setUser(data.Value);
      } catch (error) {
        console.log(error);
      }
    };
    getUserData();
  }, [stateAuth]);
  const logOut = () => {
    const logOutPanel = async () => {
      try {
        await logoutService();
        localStorage.removeItem(LOCAL_STORAGE_AUTH_KEY);
        navigate("/login");
      } catch (error) {
        console.log(error);
      }
    };
    logOutPanel();
  };

  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const imageLoaded = () => {
    console.log("Image loaded!");
    setImageLoading(false);
  };
  return (
    <section className="container mx-auto flex flex-col md:grid md:gap-4 md:grid-cols-8 py-3 px-3 relative">
      <div className="md:col-span-2 md:h-screen md:sticky md:top-3 mb-4">
        <div className="shadow-lg rounded-md border border-stone-100 p-4 bg-white text-center">
          <div
            className={`${
              imageLoading ? "block" : "hidden"
            } w-16 h-16 rounded-full overflow-hidden mx-auto`}
          >
            <img alt="agency logo" src={agencyLogo} />
          </div>
          <div
            className={`${
              imageLoading ? "hidden" : "block"
            } w-16 h-16 rounded-full overflow-hidden mx-auto`}
          >
            <img
              alt="agency logo"
              src={`https://kite.ir/${user.SupplierLogoFileName}`}
              onLoad={imageLoaded}
            />
          </div>
          <div className="mt-3">{user.SupplierTitle}</div>
        </div>
        <div className="shadow-lg rounded-md border border-stone-100 bg-white mt-4">
          <ul className="flex md:flex-col md:justify-start md:items-start justify-between items-center">
            <li className="md:w-full">
              <NavLink
                to="/tourlist"
                className={(navData) =>
                  navData.isActive
                    ? "flex w-full gap-2 items-center justify-center md:justify-start text-sm font-medium cursor-pointer px-2 pt-4 pb-3 bg-slate-100 hover:text-slate-700 text-black border border-x-0 border-t-2 border-b-0 md:border-y-0 md:border-l-0 md:border-r-4 border-lightGreenKite"
                    : "flex w-full gap-2 items-center justify-center md:justify-start text-sm font-medium cursor-pointer px-1 pt-4 pb-3 hover:bg-slate-100 hover:text-slate-700 text-slate-400"
                }
                onClick={() => setActiveTab(1)}
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 6h16M4 10h16M4 14h16M4 18h16"
                    />
                  </svg>
                </span>
                <span
                  className={`${activeTab === 1 ? "block" : "hidden md:block"}`}
                >
                  لیست تور‌ها
                </span>
              </NavLink>
            </li>
            <li className="md:w-full">
              <NavLink
                to="/AddPackage"
                className={(navData) =>
                  navData.isActive
                    ? "flex w-full gap-2 items-center justify-center md:justify-start text-sm font-medium cursor-pointer px-2 pt-4 pb-3 bg-slate-100 hover:text-slate-700 text-black border border-x-0 border-t-2 border-b-0 md:border-y-0 md:border-l-0 md:border-r-4 border-lightGreenKite"
                    : "flex w-full gap-2 items-center justify-center md:justify-start text-sm font-medium cursor-pointer px-1 pt-4 pb-3 hover:bg-slate-100 hover:text-slate-700 text-slate-400"
                }
                onClick={() => setActiveTab(2)}
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 4v16m8-8H4"
                    />
                  </svg>
                </span>
                <span
                  className={`${activeTab === 2 ? "block" : "hidden md:block"}`}
                >
                  تعریف تور
                </span>
              </NavLink>
            </li>
            <li className="md:w-full">
              <NavLink
                to="/info"
                className={(navData) =>
                  navData.isActive
                    ? "flex w-full gap-2 items-center justify-center md:justify-start text-sm font-medium cursor-pointer px-2 pt-4 pb-3 bg-slate-100 hover:text-slate-700 text-black border border-x-0 border-t-2 border-b-0 md:border-y-0 md:border-l-0 md:border-r-4 border-lightGreenKite"
                    : "flex w-full gap-2 items-center justify-center md:justify-start text-sm font-medium cursor-pointer px-1 pt-4 pb-3 hover:bg-slate-100 hover:text-slate-700 text-slate-400"
                }
                onClick={() => setActiveTab(3)}
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </span>
                <span
                  className={`${activeTab === 3 ? "block" : "hidden md:block"}`}
                >
                  اطلاعات حساب کاربری
                </span>
              </NavLink>
            </li>
            <li className="md:w-full">
              <NavLink
                to="/rules"
                className={(navData) =>
                  navData.isActive
                    ? "flex w-full gap-2 items-center justify-center md:justify-start text-sm font-medium cursor-pointer px-2 pt-4 pb-3 bg-slate-100 hover:text-slate-700 text-black border border-x-0 border-t-2 border-b-0 md:border-y-0 md:border-l-0 md:border-r-4 border-lightGreenKite"
                    : "flex w-full gap-2 items-center justify-center md:justify-start text-sm font-medium cursor-pointer px-1 pt-4 pb-3 hover:bg-slate-100 hover:text-slate-700 text-slate-400"
                }
                onClick={() => setActiveTab(4)}
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                    />
                  </svg>
                </span>
                <span
                  className={`${activeTab === 4 ? "block" : "hidden md:block"}`}
                >
                  قوانین و مقررات
                </span>
              </NavLink>
            </li>
            <li className="md:w-full">
              {" "}
              <a
                href={`https://kite.ir/agency/${user.SupplierURL}`}
                target="_blank"
                className={`flex w-full gap-2 items-center justify-center md:justify-start text-sm font-medium cursor-pointer px-2 pt-4 pb-2 hover:bg-slate-100 hover:text-slate-700 text-slate-400`}
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                </span>
                <span className="hidden md:block">صفحه آژانس</span>
              </a>
            </li>
            <li className="md:w-full" onClick={handleOpenModal}>
              <span
                className={`flex w-full gap-2 items-center justify-center md:justify-start text-sm font-medium cursor-pointer px-2 pt-4 pb-2 md:pb-4 hover:bg-slate-100 hover:text-slate-700 text-slate-400`}
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    />
                  </svg>
                </span>
                <span className="hidden md:block">خروج</span>
              </span>
            </li>
            <Modal
              open={openModal}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box className="absolute top-1/2 -translate-y-1/2 bg-slate-200 mx-auto left-0 right-0 w-1/3 text-center p-4 rounded-xl">
                <div>آیا میخواهید از حساب کاربری خود خارج شوید ؟</div>
                <div className="flex mt-5 justify-around">
                  <button
                    onClick={logOut}
                    className="bg-lightGreenKite px-7 py-1 text-white rounded-lg"
                  >
                    بله
                  </button>
                  <button
                    onClick={handleCloseModal}
                    className="bg-lightGrayKite px-7 py-1 text-white rounded-lg"
                  >
                    خیر
                  </button>
                </div>
              </Box>
            </Modal>
          </ul>
        </div>
      </div>
      <div className="md:col-span-6">
        <Outlet context={[activeTab, setActiveTab]} />
      </div>
    </section>
  );
};

export default Dashborad;
